import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/liquidity-pools.tsx");
